<template>
    <li
        :class="{
            item_has_sub_menu: hasChildren,
            active: isActive
        }"
    >
        <a @click.prevent="onListClick">
            {{ item.text }}
        </a>

        <navigation-sub-menu v-if="isActive" :items="item.navigationItems" />
    </li>
</template>

<script>
import isExternalLink from '@/helpers/isExternalLink';

export default {
    name: 'NavigationMenuItem',

    components: {
        NavigationSubMenu: () =>
            import('@/components/articles/NavigationSubMenu.vue')
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isActive: false
        };
    },

    computed: {
        hasChildren() {
            return !!this.item.navigationItems?.length;
        }
    },

    methods: {
        onListClick() {
            if (this.hasChildren) {
                this.isActive = !this.isActive;

                return;
            }

            this.onClick(this.item);
        },

        onClick(item) {
            const {
                link,
                blank = false,
                doesRedirectToAnotherPage = false
            } = item;

            if (doesRedirectToAnotherPage) {
                if (isExternalLink(link)) {
                    window.open(link, `${blank ? '_blank' : '_self'}`);

                    return;
                }

                this.$router.push(this.localePath(link));

                return;
            }

            const element = document.getElementById(link);

            if (!element) {
                return;
            }

            window.scrollTo({
                top: element.offsetTop,
                behavior: 'smooth'
            });
        }
    }
};
</script>
